import styled from 'styled-components'
import media from 'styled-media-query'
import { Text } from '@/style-guide'
import { Avatar } from 'antd'
import { suggestiveColor, white, confirmationColor } from '@/style-guide/colors'

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-right: 16px;
  ${media.greaterThan('medium')`
    padding-left: 0px;
  `}
`

export const TitleContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
`
export const AvatarCustom = styled(Avatar)`
  border-radius: 8px;
  background-color: #f56a00;
  span.ant-avatar-string {
    font-size: 50px;
    font-weight: bold;
  }
`
export const TextSpot = styled(Text)`
  color: #ec6350;
  display: block;
`
export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const TitleText = styled.div`
  font-size: 18px;
  line-height: 30px;
  font-weight: bold;
  color: #333;
  padding-bottom: 10px;
`
export const Line = styled.div`
  height: 1px;
  background-color: ${suggestiveColor}
  margin: 25px 0;
`
export const SummaryLine = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`
export const EarlyBird = styled.span`
  color: ${confirmationColor};
`

export const DiscountBox = styled.span`
  border: 1px solid ${confirmationColor};
  border-radius: 5px;
  font-size: 13px;
  padding: 2px 5px;
`

export const OptionText = styled(Text)`
  font-size: ${(props) => props.size || 14}px;
  line-height: 30px;
  font-weight: bold;
  color: #333;
  padding-left: 10px;
`
export const OptionLabelText = styled(Text)`
  font-size: 14px;
  line-height: 30px;
  color: #666;
  padding-left: 10px;
`

export const SummaryText = styled(Text)`
  font-size: 16px;
  line-height: 30px;
  font-weight: ${(props) => props.weight || 'bold'};
  color: #333;
  padding-top: 10px;
`
export const PageTitle = styled(Text)`
  display: block;
  font: bold 24px / 29px Cabin;
  color: rgb(72, 72, 72);
  margin-bottom: 5px;
  text-align: center;
`
export const PageSubTitle = styled(Text)`
  display: block;
  font: 16px Cabin;
  color: rgb(112, 112, 112);
  text-align: center;
`
export const Title = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 24px;
  margin-top: 2px;
`
export const FullNameText = styled(Text)`
  margin-top: 2px;
  line-height: 20px;
  color: #484848;
  font-weight: bold;
`

export const UserNameText = styled.span`
  line-height: 25px;
  color: #484848;
  font-size: 14px;
  font-weight: bold;
  color: #20a39e;
  cursor: pointer;
`
